export const osnUploadIcon = {
  // eslint-disable-next-line max-len
  data: `<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 11V12C1 13.1046 1.89543 14 3 14H13C14.1046 14 15 13.1046 15 12V11" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M8 10.5V1.5M8 1.5L12 5.5M8 1.5L4 5.5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>`,
  name: 'upload',
};
